import React from 'react';

const Footer = ({ scrollTo }) => {
  return (
    <footer className="bg-emerald-50/30 text-emerald-950 py-16 md:py-24 px-6 border-t border-emerald-100 relative overflow-hidden">
      {/* Green Glow from Top */}
      <div className="absolute top-0 left-0 w-full h-40 bg-emerald-500/20 blur-[100px] rounded-[100%] -translate-y-1/2 pointer-events-none"></div>

      {/* Green Glow from Bottom */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-emerald-500/20 blur-[100px] rounded-[100%] translate-y-1/2 pointer-events-none"></div>

      {/* Subtle Nature Texture Overlay */}
      <div className="absolute inset-0 pattern-overlay opacity-10 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16 items-start">

          {/* Left Section: Brand & Location */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left gap-8">
            <div className="flex flex-col items-center md:items-start gap-6">
              <img
                src="/images/logo.png"
                alt="Footer Logo"
                className="h-40 w-40 object-contain drop-shadow-[0_0_25px_rgba(255,255,255,0.9)] filter brightness-110 contrast-110"
              />

              <div className="space-y-1">
                <h2 className="serif text-4xl font-bold italic text-emerald-700 tracking-tight">Jaladhara</h2>
                <h3 className="text-xs uppercase tracking-[0.3em] font-bold text-emerald-900/60">Tourism & Camping</h3>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center md:items-start gap-4 p-4 bg-emerald-50 rounded-2xl border border-emerald-100 w-full md:w-auto">
              <div className="w-10 h-10 rounded-xl bg-emerald-600 flex items-center justify-center text-white shrink-0 shadow-lg shadow-emerald-200">
                <i className="fas fa-map-location-dot"></i>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-[10px] uppercase font-bold text-emerald-600 tracking-widest">Our Base Camp</span>
                <p className="text-emerald-900/70 text-sm leading-relaxed font-medium">
                  
                  Boduluru Road,<br />
                  Maredumilli,<br />
                  Polavaram District,<br />
                  Andhra Pradesh - 533295.
                </p>
              </div>
            </div>
          </div>

          {/* Center Section: Navigation */}
          <div className="flex flex-col items-center text-center">
            <div className="relative inline-block mb-10">
              <span className="text-xs font-bold uppercase tracking-[0.4em] text-emerald-600">Explore</span>
              <div className="h-1 w-10 bg-emerald-600 mx-auto mt-2 rounded-full"></div>
            </div>
            <ul className="grid grid-cols-1 gap-6">
              <li><button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">Home</button></li>
              <li><button onClick={() => scrollTo('accommodations')} className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">The Stays</button></li>
              <li><button onClick={() => scrollTo('wonders')} className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">Wilderness</button></li>
              <li><button onClick={() => scrollTo('about')} className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">Our Story</button></li>
              <li><button onClick={() => scrollTo('contact')} className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">Contact</button></li>
              {/* <li><a href="/login" className="text-sm font-bold uppercase tracking-[0.2em] text-emerald-900/60 hover:text-emerald-600 transition duration-300">Admin Dashboard</a></li> */}
            </ul>
          </div>

          {/* Right Section: Connect */}
          <div className="flex flex-col items-center md:items-end text-center md:text-right gap-10">
            <div className="space-y-3">
              <span className="text-xs font-bold uppercase tracking-[0.4em] text-emerald-600 block">Reservations</span>
              <p className="text-3xl font-bold text-emerald-950 tracking-tighter transition-transform hover:scale-105 inline-block">+91 94407 66328</p>
              <div className="flex items-center justify-center md:justify-end gap-2 text-emerald-600/60 text-[10px] font-bold uppercase tracking-widest">
                <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span> Open for Booking
              </div>
            </div>

            <div className="flex flex-col items-center md:items-end gap-6 w-full">
              <span className="text-[10px] uppercase font-bold text-emerald-900/40 tracking-[0.3em]">Join our community</span>
              <div className="flex gap-4">
                <button className="w-12 h-12 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-700 hover:bg-emerald-600 hover:text-white transition-all transform hover:-translate-y-2 shadow-sm"><i className="fab fa-instagram"></i></button>
                <a href="https://wa.me/919440766328" className="w-12 h-12 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-700 hover:bg-emerald-600 hover:text-white transition-all transform hover:-translate-y-2 shadow-sm"><i className="fab fa-whatsapp"></i></a>
                <button className="w-12 h-12 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center text-emerald-700 hover:bg-emerald-600 hover:text-white transition-all transform hover:-translate-y-2 shadow-sm"><i className="fab fa-facebook-f"></i></button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="mt-20 pt-10 border-t border-emerald-50 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[10px] text-emerald-950/30 uppercase tracking-[0.4em] font-bold">
            &copy; 2026 Jaladhara Tourism & Camping | Maredumilli, AP
          </p>
          <div className="flex gap-8 text-[10px] font-bold text-emerald-950/40 uppercase tracking-widest">
            <button className="hover:text-emerald-600 transition">Privacy</button>
            <button className="hover:text-emerald-600 transition">Terms</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
